export class Reducer {
    reduce<T>(dataArray: T[],
        keyer: (data: T) => string,
        combiner: (a: T, b: T) => T,
        cloner: (source: T) => T): T[] {
        const reducedResult: T[] = [];
        // Separate into an Object with an attribute per key with the value being
        // an Array of elements matching that key.
        const groupedByKey = dataArray.reduce((grouped, data) => {
            if (!data) {
                return grouped;
            }
            const key = keyer(data);
            grouped[key] = grouped[key] || [];
            grouped[key].push(data);
            return grouped;
        }, {});
        // For each Key, let us now mathematically reduce the arrays into a single element
        Object.keys(groupedByKey)
            .map((key: string) => {
                const dataForKey: T[] = groupedByKey[key];
                const reduced: T = dataForKey
                    .reduce((prev, current, index) => {
                        if (!prev) {
                            return cloner(current);
                        }
                        if (index === 1) {
                            prev = cloner(prev);
                        }
                        return combiner(prev, current);
                    });
                reducedResult.push(reduced);
            });
        return reducedResult;
    }
}
